import ErrorNotFound from '@/pages/errors/E404'
import Index from '@/pages/Index'
import Login from '@/pages/Login'

export default [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/e404',
    name: 'ErrorNotFound',
    component: ErrorNotFound
  },
  {
    path: '*',
    redirect: {name: 'ErrorNotFound'}
  }
]



// WEBPACK FOOTER //
// ./src/router/common.js